import SimplexNoise from "./SimplexNoise";

export default class FractionalBrownianMotion {
    /**
     * @param {number} seed
     * @param {number} terrainAmplitude The amplitude is how tall the features should be.
     * @param {number} terrainLacunarity Lacunarity is what makes the frequency grow. Each octave the frequency is multiplied by the lacunarity.
     * @param {number} terrainGain Gain is what makes the amplitude shrink (or not shrink).
     * @param {number} terrainOctaves Octaves are how many layers you are putting together.
     * @param {number} terrainFrequencyMultiplier The frequency of a layer is how many points fit into the space you've created.
     */
    constructor(seed, terrainAmplitude, terrainLacunarity, terrainGain, terrainOctaves, terrainFrequencyMultiplier) {

        // /**
        //  * @constant
        //  * @private
        //  * @type {PerlinNoise}
        //  */
        // this.perlinNoise = new PerlinNoise(seed);

        /**
         * @constant
         * @private
         * @type {SimplexNoise}
         */
        this.simplexNoise = new SimplexNoise(seed);

        /**
         * @constant
         * @type {number}
         */
        this.terrainAmplitude = terrainAmplitude;
        /**
         * @constant
         * @type {number}
         */
        this.terrainLacunarity = terrainLacunarity;
        /**
         * @constant
         * @type {number}
         */
        this.terrainGain = terrainGain;
        /**
         * @constant
         * @type {number}
         */
        this.terrainOctaves = terrainOctaves;
        /**
         * @constant
         * @type {number}
         */
        this.terrainFrequencyMultiplier = terrainFrequencyMultiplier;
    }


    // https://www.redblobgames.com/maps/terrain-from-noise/

    // const TAU = 2 * M_PI;

    // function cylindernoise(double nx, double ny) {
    //     double angle_x = TAU * nx;
    //     /* In "noise parameter space", we need nx and ny to travel the
    //        same distance. The circle created from nx needs to have
    //        circumference=1 to match the length=1 line created from ny,
    //        which means the circle's radius is 1/2π, or 1/tau */
    //     return noise3D(cos(angle_x) / TAU, sin(angle_x) / TAU, ny);
    // }


    // /**
    //  * Cylinder world
    //  * @param {number} x The x coordinate.
    //  * @param {number} y The y coordinate.
    //  * @returns {number}
    //  */
    // calculateNoise(x, y) {
    //     let sum = 0;

    //     // Make copies of amplitude and frequency because we need to modify them.
    //     let amplitude = this.terrainAmplitude;
    //     let frequency = this.terrainFrequencyMultiplier;

    //     const xRadians = 2 * Math.PI * (x / Settings.grid.worldPixelWidth); // world pixel width is the circumference.
    //     const xx = Settings.grid.pixelRadius * Math.cos(xRadians);
    //     const zz = Settings.grid.pixelRadius * Math.sin(xRadians);

    //     for (let i = 0; i < this.terrainOctaves; i++) {
    //         sum += amplitude * this.simplexNoise.noise3d(xx * frequency, zz * frequency, y * frequency);

    //         amplitude *= this.terrainGain;
    //         frequency *= this.terrainLacunarity;
    //     }

    //     return sum;   // most results are from [-0.8 to 0.2].
    // }    


    /**
     * @param {number} x The x coordinate.
     * @param {number} y The y coordinate.
     * @returns {number}
     */
    calculateNoise(x, y) {
        let sum = 0;

        // Make copies of amplitude and frequency because we need to modify them.
        let amplitude = this.terrainAmplitude;
        let frequency = this.terrainFrequencyMultiplier;

        for (let i = 0; i < this.terrainOctaves; i++) {
            sum += amplitude * this.simplexNoise.noise(x * frequency, y * frequency);

            amplitude *= this.terrainGain;
            frequency *= this.terrainLacunarity;
        }

        return sum;   // most results are from [-0.8 to 0.2].
    }    
}